import React, { useState, useEffect } from "react";
import {
    StyleSheet, View, Text
} from "react-native";

import { FONT } from "../../../value/staticValues";
import { PLATFORM_URL } from "../../../value/Url";
import { requests } from "../../../common/RestAPI";

import { CustomTextInput, TextArea } from "../../base/CustomInputText";
import { ReactComponent as MsgInfoImg } from '../../../img/ico-msg-info-2.svg';
import { useTranslation } from "react-i18next";
import CustomText from "components/base/CustomText";


interface ArgsType {
    host_id: string;
    host_name: string;
    gpu_total_count: number;
    ip_address: string;
    deploy_ip_address: string;
}

interface HostUpdateProps {
    showMessageCb?: Function,
    showLoadingCb?: Function,
    stepIndex: number,
    clickedConfirmYn: boolean,
    resultCb?: Function,
    stepCount: number,
    args?: ArgsType,
}

HostUpdate.defaultProps = {
    stepIndex: 0,
    clickedConfirmYn: false,
    stepCount: 1,
}

export default function HostUpdate(props:HostUpdateProps) {
    const { t } = useTranslation();
    const [stepIndex, setStepIndex] = useState(0);
    const [executeUpdateYn, setExecuteUpdateYn] = useState(false);

    const [gpuTotalCount, setGpuTotalCount] = useState(props.args?.gpu_total_count);
    

    useEffect(() => {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        setStepIndex(props.stepIndex);
    }, [props.stepIndex]);

    useEffect(() => {
        if(props.clickedConfirmYn === true) {
            setExecuteUpdateYn(true);
        }
    }, [props.clickedConfirmYn]);

    useEffect(() => {
        if(executeUpdateYn) {
            executeUpdateHost();
        }
    }, [executeUpdateYn]);

    function executeResult(result, closeYn, infoMessage) {
        if(props.showMessageCb && infoMessage) {
            props.showMessageCb(infoMessage);
        }
        if(props.resultCb) {
            props.resultCb(result, closeYn);
        }
    }

    function executeUpdateHost() {
        const body = {
            host: {
                gpu_total_count: gpuTotalCount ? Number(gpuTotalCount) : 0,
            }
        };

        requests.put(PLATFORM_URL.HOST + '/' + props.args?.host_id, body)
        .then((response) => {
            if(response.status === 200) {
                executeResult({successYn: true }, true, "");
            } else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }

        })
        .catch((error) => {
            executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
        });
    }
    return (
        <View>
            {
                stepIndex === 0 ?
                <View>
                    <View style={style.infoBoxContainer}>
                        <MsgInfoImg/>
                        <Text style={style.infoBoxContainerText}>
                            {t("HOST_UPDATE_INFO_MESSAGE")}
                        </Text>
                    </View>
                    <Text style={style.titleText}>{
                        t("BASE_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("HOST_NAME_TEXT")}
                            </Text>
                            <Text style={style.columeData}>
                                {props.args?.host_name}
                            </Text>
                        </View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("HOST_MANAGEMENT_IP_TEXT")}
                            </Text>
                            <Text style={style.columeData}>
                                {props.args?.ip_address}
                            </Text>
                        </View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("HOST_SSH_IP_TEXT")}
                            </Text>
                            <Text style={style.columeData}>
                                {props.args?.deploy_ip_address}
                            </Text>
                        </View>
                        <Text style={{...style.rowDescribeContainer, marginBottom: 20}}>
                            {t("HOST_IP_DESCRIBE_MESSAGE")}
                        </Text>
                        <View style={style.rowDivContainer}/>
                        <View style={style.rowContainer}>
                            <CustomText text={t("HOST_GPU_TOTAL_COUNT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomTextInput
                                key={1}
                                width={250} height={36}
                                value={gpuTotalCount ? gpuTotalCount + "" : "0"}
                                type={"number"}
                                activeYn={true}
                                inputCb={(v)=>setGpuTotalCount(Number(v))}
                                warnYn={false}
                            />
                            <Text style={style.diskUsageText}>
                                {t("UNIT_TEXT")}
                            </Text>
                        </View>
                        <Text style={{...style.rowDescribeContainer, marginBottom: 20}}>
                            {t("HOST_GPU_TOTAL_COUNT_DESCRIBE_MESSAGE")}
                        </Text>
                    </View>
                </View>
                :null
            }
        </View>
    )
}


const style = StyleSheet.create({
    titleText: {
        marginTop: 40,
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        fontWeight: "500",
        color: "#0853fb",
    },
    mainContainer: {
        marginTop: 38
    },
    rowContainer: {
        height: 36,
        flexDirection: "row",
        marginBottom: 30,
        alignItems: "center"
    },
    rowTopAlignContainer: {
        minHeight: 36,
        flexDirection: "row",
        marginBottom: 30,
    },
    rowDivContainer: {
        borderStyle: "solid",
        borderBottomWidth: 1,
        borderBottomColor: "#eee",
        marginBottom: 30,
    },

    rowDescribeContainer: {
        marginLeft: 150, marginTop: -10, marginBottom: 40,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 12,
        color: "#8c8c8c"
    },
    columnText: {
        width: 150,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
    },
    infoBoxContainer: {
        flexDirection: "row", alignItems: "center",
        width: 700, height: 40,
        paddingLeft: 10, paddingRight: 10,
        marginBottom: 15,
        borderRadius: 2,
        backgroundColor: "#fafafa"
    },
    infoBoxContainerText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 18,
        color: "#9ea0a5"
    },
    diskUsageText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 11,
        lineHeight: 10,
        color: "#9ea0a5"
    },
    rowInfoText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 11,
        lineHeight: 10,
        color: "#9ea0a5"
    },
    rowStaticText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333"
    },
    dateText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#9ea0a5"
    },
    columeData: {
        width: 550,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
        overflow: "scroll"
    },
});

const labelStyle = {
    fontFamily: FONT.REGULAR,
    fontSize: 12,
    color: "#333"
}